/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingMemoryForAzureAi extends models.BaseCostProcessingMemory {
    constructor() {
        super();
        this.setDiscriminator("CostProcessingMemoryForAzureAi");
    }

    getFixupPrototypeFunction() { return CostProcessingMemoryForAzureAi.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingMemoryForAzureAi>): CostProcessingMemoryForAzureAi {
        let obj = Object.assign(new CostProcessingMemoryForAzureAi(), model);
        CostProcessingMemoryForAzureAi.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingMemoryForAzureAi>): CostProcessingMemoryForAzureAi {
        if (!model) return null;
        return CostProcessingMemoryForAzureAi.newInstance(<CostProcessingMemoryForAzureAi> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingMemoryForAzureAi) {
        if (!obj) return;

        models.CostProcessingMemoryForAzureAi.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingMemoryForAzureAi): boolean {
        if (models.BaseCostProcessingMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingMemoryForAzureAi.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.periods) {
            for (let val of this.periods) {
                models.BaseCostProcessingPeriodMemory.fixupPrototype(val);
            }
        }
    }

    /**
     * Attributed billing periods
     */
    periods: Array<models.BaseCostProcessingPeriodMemory>;

}
